import React from 'react';
import LineIcon from '../Icons/LineIcon';
import { cc } from '../../modules/styles';
import './MenuSubheader.css';

/**
 * Header of a sub-section in the Menu
 */

const MenuSubheader = ({ name, onActionRequest, className }) => {
  return (
    <div className={cc('MenuSubheader', className)}>
      <div className="MenuSubheader__text">{name}</div>
      {!!onActionRequest && (
        <button className="MenuSubheader__button" onClick={onActionRequest}>
          <LineIcon type="plus" width={14} thickness={3} />
        </button>
      )}
    </div>
  );
};

export default MenuSubheader;
